import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFashion: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fashion, wear, clothes, t-shirt"><path d="M20.7125 11.5768L22.25 7.25L15.075 3.75C14.0732 7.01444 9.92685 7.01444 8.925 3.75L1.75 7.25L3.2875 11.5768L5.75 10.45V20.25H18.25V10.45L20.7125 11.5768Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFashion;
